<template>
  <div class="home-social-column">
    <!-- <div class="home-social-row"> -->
    <div @click="openNewTab('https://de.linkedin.com/company/takt-ing')" class="" style="cursor: pointer;height: 50%; display: flex; justify-content: center; align-items: center">
      <img style="" height="70%" src="@/assets/LinkedIn.png">
    <!-- </div> -->
  </div>
  <!-- <div class="home-social-row"> -->
    <div @click="openNewTab('https://www.youtube.com/channel/UC2QoKazqAfnJeolHcz8w6iw')" class="" style="cursor: pointer; height: 50%; display: flex; justify-content: center; align-items: center">
      <img style="" height="40%" :src="require($vuetify.theme.dark ? '@/assets/youtubeLogo.png' : '@/assets/youtubeLogoBlack.png')">
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
  export default {
    methods: {
      openNewTab(route) {
        window.open(route)
      }
    }
  }
</script>

<style>
.home-social-column {
  width: 100%;
  height: 100%;
  /* background-color: red; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* gap: 5px; */
}
.home-social-row {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 5px;
}

</style>
